import React from "react";
import styled from "styled-components";
import TextField from "@mui/material/TextField";

type Props = {
  type?: string;
  placeholder?: string;
  required?: boolean;
  inputwidth?: string | any;
  formik?: any;
  name?: string | any;
  multiline?: boolean;
  handleChange?: (event: any) => void;
  handleBlur?: (event: any) => void;
  onMouseOver?: (event: any) => void;
  value?: string | number;
  hasError?: boolean;
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  login?: boolean;
};

const InputField = ({
  type = "text",
  placeholder,
  required,
  inputwidth = "100",
  formik,
  name,
  multiline = false,
  handleChange,
  handleBlur,
  onMouseOver,
  value,
  hasError = false,
  autoFocus = false,
  className,
  disabled = false,
  login = false,
  ...props
}: Props) => {
  return (
    <StyledInput
      {...props}
      multiline={multiline}
      type={type}
      name={name}
      placeholder={placeholder}
      required={required}
      inputwidth={inputwidth}
      onBlur={formik?.handleBlur || handleBlur}
      value={formik?.values[`${name}`] || value || ""}
      onChange={formik?.handleChange || handleChange}
      autoFocus={autoFocus}
      className={className}
      onMouseEnter={onMouseOver}
      disabled={disabled}
      login={login}
      error={
        Boolean(formik?.touched[`${name}`] && formik?.errors[`${name}`]) ||
        hasError
      }
    />
  );
};

export default InputField;

const StyledInput: any = styled(TextField)`
  width: ${(props: any) => props?.inputwidth && parseInt(props?.inputwidth)}%;

  .MuiInputBase-root {
    background: var(--card-bg);
    border: 2px solid var(--card-border);
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      border-color: var(--accent);
    }

    &.Mui-focused {
      border-color: var(--accent);
      box-shadow: 0 0 0 3px rgba(217, 58, 53, 0.1);
    }

    &.Mui-error {
      border-color: var(--accent);
    }

    ${(props: any) => props?.login && `border-radius: 8px !important;`}
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  input, textarea {
    color: var(--text-primary) !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;

    &::placeholder {
      color: var(--text-secondary) !important;
      opacity: 0.7 !important;
    }
  }

  input {
    height: 40px !important;
    padding: 0 15px !important;
    ${(props: any) =>
      props?.login &&
      `background: rgba(50, 61, 134, 0.11) !important;
      outline: none !important;
      border-radius: 8px !important;
      border: 2px solid #303e8a !important;
      color: #2b3b7c !important;
      font-weight: 500 !important;
      font-size: 14px !important;
      `}
  }

  textarea {
    padding: 15px !important;
    min-height: 100px;
  }

  input:disabled, textarea:disabled {
    background-color: var(--bg-secondary) !important;
    color: var(--text-secondary) !important;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-family: "Poppins", sans-serif !important;
    color: var(--text-secondary) !important;
  }
  input::-moz-placeholder,
  textarea::-moz-placeholder {
    font-family: "Poppins", sans-serif !important;
    color: var(--text-secondary) !important;
  }
  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    font-family: "Poppins", sans-serif !important;
    color: var(--text-secondary) !important;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
